module.exports = __webpack_public_path__ + "img/2021_10_dande_pari_1025-3_web.2e5ea9c4.png";